/**
 * Encontrar una categoría por su NOMBRE, no por su id.
 *
 * ── POR QUÉ ESTO EXISTE ─────────────────────────────────────────────────────
 *
 * Las categorías nacen en cada dispositivo con ids al azar. El celular de
 * Esteban tiene su "Parqueadero" con un id; el servidor no lo conoce. Cuando
 * el asistente cuadró sus cuentas desde el servidor, anotó el parqueadero,
 * los detalles y las comidas sin categoría, aunque Esteban había dicho qué
 * era cada cosa. Tuvo razón en reclamarlo.
 *
 * La salida: quien no conoce los ids deja el NOMBRE ("categoria_nombre") y
 * cada dispositivo, al abrir, lo cambia por el id de SU categoría con ese
 * nombre. Sirve igual para lo que lea la IA de un extracto.
 */

/** Minúsculas, sin tildes, sin espacios de sobra: "Almuerzo del trabajo" = "almuerzo del  TRABAJO". */
export function normalizarNombre(texto) {
  return String(texto ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * La categoría viva con ese nombre y ese tipo. Si hay una subcategoría y un
 * grupo con el mismo nombre ("Donaciones" > "Donaciones"), gana la
 * subcategoría: es la más precisa.
 *
 * @param {Array}  categorias
 * @param {string} nombre
 * @param {'egreso'|'ingreso'} tipo
 * @returns {object|null}
 */
export function buscarCategoria(categorias, nombre, tipo = 'egreso') {
  const buscado = normalizarNombre(nombre);
  if (!buscado) return null;
  const candidatas = (categorias ?? []).filter((c) =>
    !c.borrado_en && !c.archivada && c.tipo === tipo && normalizarNombre(c.nombre) === buscado);
  return candidatas.find((c) => c.padre_id) ?? candidatas[0] ?? null;
}
